import React, {useEffect} from "react";

import { Advertiser } from "./Advertiser.js";
import { isEmpty } from "weed-js";

const Home = ({openCreateAccount}) => {

    useEffect(() => {
        if (isEmpty(document)) {
            return;
        }
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/pricing-table.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [true]);

    return <Advertiser openCreateAccount={openCreateAccount}/>
};

export default Home;